import React, { ReactNode, useEffect, useState, useCallback } from 'react';
import styled, { css, keyframes } from 'styled-components';
import Gallery, { RenderImageProps } from 'react-photo-gallery';

import ImageItem from './ImageItem';

import config from '../../../../lib/config-api.json';
import FindURL from '../../common/FindURL';
import { PayloadResult } from '../../../../lib/tabAI/recommendType';
import { PostConsumptionBodyType } from '../../../../lib/common/type';

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
}

const ImageListComponent = styled.div`
  position: relative;
  width: 100%;
  margin-top: 26px;
`;

const ImageListTitle = styled.div`
  margin-bottom: 6px;
  height: 24px;
  font-size: 16px;
  font-weight: 500;
`;

type ImageListProps = {
  recommendData: PayloadResult;
  onPostConsumption: (info: PostConsumptionBodyType) => void;
};

type ImageListState = {
  reBuildImageData:
    | {
        id: number;
        url: string;
        src: string;
        width: number;
        height: number;
        alt: string;
        targetId?: number;
        title?: string | undefined;
        desc?: string | undefined;
        source?: string | undefined;
      }[]
    | null;
};

const ImageList = ({ recommendData, onPostConsumption }: ImageListProps) => {
  const [reBuildImageData, setRebuildImageData] = useState<
    ImageListState['reBuildImageData']
  >(null);
  useEffect(() => {
    const src = apiInfo.api_url_image;

    const reBuildImageData: {
      id: number;
      url: string;
      src: string;
      width: number;
      height: number;
      alt: string;
      targetId?: number;
      title?: string | undefined;
      desc?: string | undefined;
      source?: string | undefined;
    }[] = [];

    if (
      recommendData.travel_info_image &&
      recommendData.travel_info_image.results
    ) {
      recommendData.travel_info_image.results.some((element, index) => {
        let urlInfo: {
          url: string;
          source: string;
        } = { url: '', source: '' };
        let targetId = 0;
        let width = 1;
        let height = 1;

        if (element.travel_info_id) {
          urlInfo = FindURL(element.cot_id, 0);
          targetId = 0;
        } else if (element.recommended_info_id) {
          urlInfo = FindURL(element.cot_id, 1);
          targetId = 1;
        }
        const { title } = element;
        const content = '';

        if (element.image_meta) {
          const { size } = element.image_meta;
          [width, height] = [size[0], size[1]];
        }

        if (
          index > 9 ||
          (recommendData.recommended_info_image &&
            recommendData.recommended_info_image.total > 5 &&
            index > 5)
        ) {
          return true;
        }
        reBuildImageData.push({
          id: element.id,
          url: urlInfo.url,
          src: `${src}${element.image}`,
          alt: `${index}`,
          targetId,
          width,
          height,
          title,
          desc: content,
          source: urlInfo.source,
        });
        return false;
      });
      if (reBuildImageData.length < 3) {
        while (reBuildImageData.length < 3) {
          reBuildImageData.push({
            id: 5,
            url: '',
            width: 0,
            height: 0,
            targetId: 0,
            src: '',
            alt: '',
          });
        }
      }
    }

    if (
      recommendData.recommended_info_image &&
      recommendData.recommended_info_image.results
    ) {
      recommendData.recommended_info_image.results.some((element, index) => {
        let urlInfo: {
          url: string;
          source: string;
        } = { url: '', source: '' };
        let targetId = 0;

        if (element.travel_info_id) {
          urlInfo = FindURL(element.cot_id, 0);
          targetId = 0;
        } else if (element.recommended_info_id) {
          urlInfo = FindURL(element.cot_id, 1);
          targetId = 1;
        }
        const { title } = element;
        const content = '';

        if (
          index > 9 ||
          (recommendData.travel_info_image &&
            recommendData.travel_info_image.total > 5 &&
            index > 5)
        ) {
          return true;
        }
        reBuildImageData.push({
          id: element.id,
          url: urlInfo.url,
          src: `${src}${element.image}`,
          alt: `${index}`,
          targetId,
          width: 1,
          height: 1,
          title,
          desc: content,
          source: urlInfo.source,
        });
        return false;
      });
      if (reBuildImageData.length < 3) {
        while (reBuildImageData.length < 3) {
          reBuildImageData.push({
            id: 5,
            url: '',
            width: 0,
            height: 0,
            targetId: 0,
            src: '',
            alt: '',
          });
        }
      }
    }
    setRebuildImageData(reBuildImageData);
  }, [recommendData]);
  const imageRenderer = useCallback(
    ({
      left,
      top,
      photo,
      onClick,
      direction,
      margin,
      index,
    }: RenderImageProps) => {
      const tempPhoto: {
        id?: number;
        url?: string;
        src: string;
        width: number;
        height: number;
        targetId?: number;
        alt?: string | undefined;
        title?: string;
        desc?: string;
        source?: string;
      } = photo;

      return (
        <ImageItem
          margin={margin}
          index={index}
          photo={tempPhoto}
          left={left}
          top={top}
          onClick={onClick}
          direction={direction}
          key={index}
          onPostConsumption={onPostConsumption}
        />
      );
    },
    []
  );
  return (
    <ImageListComponent>
      {reBuildImageData ? (
        <>
          <ImageListTitle>이미지</ImageListTitle>
          <Gallery
            photos={reBuildImageData}
            renderImage={imageRenderer}
            targetRowHeight={130}
            limitNodeSearch={10}
            margin={3}
          />
        </>
      ) : null}
    </ImageListComponent>
  );
};

export default ImageList;
